import { OneAlert } from '@factorialco/factorial-one-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { WorkSpaceWithBookingNode } from 'modules/space_control/hooks/useWorkSpacesWithBookings'

interface PinAlertProps {
  workSpace: WorkSpaceWithBookingNode
  onDelete: () => void
}

export const PinAlert: React.FC<PinAlertProps> = ({ workSpace, onDelete }) => (
  <OneAlert
    title={workSpace.workSpaceName}
    description={i18n.t('space_control.map.space_mapped')}
    variant="info"
    action={{
      label: i18n.t('space_control.map.remove_from_map'),
      onClick: onDelete,
    }}
  />
)
